const normalized = (value?: string | null) => (value || '').trim().toLowerCase();

// A payer may receive viewer mail for their own membership when both member
// identities belong to someone else. Missing overrides still mean the payer.
export function isOwnPayerViewer(customer: {id: string; billing_email: string; mailing_email_override?: string | null; thinkific_email_override?: string | null}, viewer: {customer_id: string; email: string}): boolean {
  const email = normalized(viewer.email);
  return !!email && customer.id === viewer.customer_id && normalized(customer.billing_email) === email
    && (normalized(customer.mailing_email_override) || normalized(customer.billing_email)) !== email
    && (normalized(customer.thinkific_email_override) || normalized(customer.billing_email)) !== email;
}
